/**
 * 回显第二步预约 内容
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param deliveryOrderId 编辑时传入此id,等同于将以有否 deliveryOrderId 判断是否编辑状态
 **/
import React from "react";
import {symbolMoneyUtil,isEmpty} from '@utils/utils';
import IconE from "@/components/Icon/E";
export default class StepSecondType extends React.Component{
    static propTypes = {
    }
    static defaultProps = {
        list:[], // 提货类型
        noClick: false, // 默认可点击
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        }
    }
    /**
     * 賦值
     * **/
    onChangeType(value){
      if(this.props.onChangeType)  this.props.onChangeType(value);
    }
    // 渲染方式
    renderType(type,value,currentType,title,icon="",iconChild){
        const { noClick } =this.props;
        return (<div className={`item${noClick?" noEdit":" cursor-p"}${currentType==value?" on":""}`}
                     key={'pickupType_'+value}
                     onClick={noClick?null:()=>this.onChangeType(value)}>
              {icon&&<i className={"font_24 "+icon}></i>}
              {iconChild}
            <div className={"fw_500"}>{title}</div>
        </div>)
    }
    init(){
        const { list } = this.props;
        let deliveryTypeList = [...list]
        if(deliveryTypeList&&deliveryTypeList.length>0){
            deliveryTypeList.forEach((item={})=>{
                if(item.type=="10"){
                    item.icon = "ri-user-fill"
                }else if(item.type=="20"){
                    item.icon = "ri-truck-fill"
                }else if(item.type=="30"){
                    item.iconChild = <IconE size={24} color={"rgba(0, 0, 0, 0.89)"} />
                }
                return item
            })
        }
        this.setState({
            deliveryTypeList:deliveryTypeList||[], //提货方式
        })
    }
    componentDidMount() {
        this.init();
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { deliveryTypeList,  } =this.state;
        const {  pickupType,} = this.props;
        return (<>
                {deliveryTypeList&&deliveryTypeList.length>0?<div className={"flex-item typeWrap"}>
                    {deliveryTypeList.map((typeObj,inx)=>this.renderType("pickupType",typeObj.type,pickupType,typeObj.name,typeObj.icon,typeObj.iconChild))}
                </div>:null}

        </>);
    }
}

